import React from 'react'

import Separator from '../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import Text from '../../../../components/pdf/Text'
import View from '../../../../components/pdf/View'

const SecondPage = () => {
  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start">
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
      </Grid>
      <Separator weight={6} />
      <Grid direction="column">
        <Col>
          <Text bold align="center" color="#938953" size={18}>
            Descrição do Produto
          </Text>
          <Separator weight={6} />
          <Grid direction="column" style={{ gap: 5 }} align="start">
            <Text align="justify">
              A SannyGold é uma empresa inovadora que oferece ao mercado modernos banheiros de luxo para locação.
              Focados em mobilidade e autonomia, oferecemos as melhores soluções em banheiros de alto padrão para
              festas, casamentos, feiras, shows e festivais. Desenvolvidos a partir de uma plataforma móvel, nossa
              solução esta baseada em banheiros exclusivos e confortáveis, independente da infraestrutura do local do
              evento. Somos a melhor opção para manter com estilo e qualidade em qualquer ocasião, oferecendo liberdade
              aos produtores de eventos e comodidade ao convidados.
            </Text>
            <Separator weight={6} />
            <Text bold color="#938953">
              Nossos diferenciais:
            </Text>
            <Separator weight={2} />
            <Text>
              ⮚ <strong>Ar Condicionado</strong> - Cabines climatizadas.
            </Text>
            <Text>
              ⮚ <strong>Detalhes Sofisticados</strong> - Torneiras automáticas, espelhos e porta bolsas.
            </Text>
            <Text>
              ⮚ <strong>Alto padrão</strong> - Odorizador automático, espuma para mãos, antisséptico bucal, fio dental,
              lenço higiênico e papel toalha premium.
            </Text>
            <Text>
              ⮚ <strong>Independência</strong> - Autossuficiência em relação a pontos de água, energia ou rede de
              esgoto.
            </Text>
            <Text>
              ⮚ <strong>Mobilidade</strong> - SannyGold é um veículo e pode ir a qualquer lugar.
            </Text>
            <Text>
              ⮚ <strong>Equipe Especializada</strong> - Constante limpeza e manutenção durante todo evento.
            </Text>
            <Text>
              ⮚ <strong>Acessibilidade</strong> - Cabine maior, rampa de acesso exclusivo e barras de apoio.
            </Text>
          </Grid>
        </Col>
        <Separator weight={10} />
        <Col>
          <Image src="/pdfs/sannygold/second-page-image.jpg" maxHeight={450} />
        </Col>
      </Grid>
    </View>
  )
}

export default SecondPage
